import { render, staticRenderFns } from "./candidateLanguage.vue?vue&type=template&id=a0aa9546&"
import script from "./candidateLanguage.vue?vue&type=script&lang=js&"
export * from "./candidateLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports